<div class="full-page-container">
  <ng-container *notInPopulation="[populations.JuniorBluebirds]">
    <fgb-banner title="{{ 'wallet.page.banner' | translate }}" class="d-lg-flex d-none"></fgb-banner>
  </ng-container>
  <ng-container *inPopulation="[populations.JuniorBluebirds]">
    <fgb-banner [isImageBanner]="true" [imageBannerUrl]="'banners/wallet-page-banner.jpg'" class="d-lg-flex d-none"></fgb-banner>
  </ng-container>

  <div class="d-block d-lg-none">
    <fgb-barcode [pageTitle]="'wallet.page.banner'" [isWalletPage]="true" [backButtonLink]="'/'"></fgb-barcode>
  </div>

  <div class="d-none d-lg-block">
    <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
  </div>

  <div #walletContainer class="wallet-container">
    <ng-container *ifScreenSize="screenType.Mobile">
      <div class="grab-point"><span class="minimize-icon"> </span></div>
    </ng-container>

    <ng-container *ngIf="walletItems$ | async as walletItems">
      <div class="wallet-redeem-carousel">
        <div class="container mt-lg-0 mt-4">
          <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
        </div>
      </div>
    </ng-container>

    <div class="container">
      <div
        class="mt-3 text-center bg-white rounded d-block d-lg-flex justify-content-between align-items-center p-3 border border-disabled"
      >
        <div class="text-start">
          <h5 class="wallet-claimed-items-heading mb-1">{{ 'rewards.wallet.claimed.title' | translate }}</h5>
          <div class="text-start font-size-14">
            {{ 'rewards.wallet.claimed.description' | translate }}
          </div>
        </div>
        <a class="font-size-14 claimed-text wallet-btn fw-bold" [routerLink]="['/rewards/claimed']">
          {{ 'rewards.wallet.view.claimed' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
